import {
  ISaleChannelForm,
  ISalesChannelResponse,
} from 'services/salesChannel/types';
import { ACTIVE_STATUS } from 'services/types';

export const salechannelQueryToForm = (
  response: ISalesChannelResponse
): ISaleChannelForm => {
  const { messageRecipient, id, ...salesChannel } = {
    ...response,
    isActive: response.isActive ? ACTIVE_STATUS.Active : ACTIVE_STATUS.Inactive,
    messageRecipientId: response.messageRecipient?.id ?? '',
    messageRecipientName: response.messageRecipient?.name ?? '',
    file: null,
    distributionFormId: response.distributionForm,
  };
  return salesChannel;
};
